<template>
  <v-simple-table class="text-left">
    <thead>
    <tr>
      <th>IdDeuda</th>
      <th>Deudor</th>
      <th>DNI</th>
      <th>Estado</th>
      <th>Saldo</th>
      <th>Monto imputado</th>
    </tr>
    </thead>

    <tbody>
    <template v-if="deudasImputadas">
      <tr v-for="(item, index) in deudasImputadas" :key="index">
        <td>{{ item.deuda ? (item.deuda.idDeuda || item.deuda.id) : '-' }}</td>
        <td>{{ item.deuda ? item.deuda.nombreDeudor : '-' }}</td>
        <td>{{ item.deuda ? item.deuda.dniDeudor : '-' }}</td>
        <td>{{ item.deuda ? item.deuda.estado : '-' }}</td>
        <td>$ {{ getMoney(item.deuda ? item.deuda.saldoCapitalCompra : null) }}</td>
        <td>$ {{ getMoney(item.montoProporcional) }}</td>
      </tr>
    </template>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  name: "DeudasImputadasSimpleTable",
  props: {
    deudasImputadas: {type: Array, default: () => []}
  },
  methods: {
    getMoney(value) {
      return typeof value === 'number' ? value.toLocaleString('es-AR') : '-'
    }
  }
}
</script>

<style scoped>

</style>
